import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { AlertCircle } from "lucide-react";

const drawerVariants = {
    hidden: { x: "100%" },
    visible: {
        x: 0,
        transition: { duration: 0.24, ease: "easeOut" },
    },
    exit: {
        x: "100%",
        transition: { duration: 0.2, ease: "easeIn" },
    },
};

const SectionBIntroModal = ({ open, onAcknowledge }) => {
    useEffect(() => {
        document.body.style.overflow = open ? "hidden" : "auto";
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [open]);

    return (
        <AnimatePresence>
            {open && (
                <>
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="fixed inset-0 z-[60] bg-black/40 backdrop-blur-[2px]"
                    />
                    <motion.div
                        variants={drawerVariants}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        className="fixed top-0 right-0 z-[61] flex h-full w-full max-w-sm flex-col bg-white shadow-2xl"
                    >
                        <div className="border-b border-[#c2a8f033] bg-[#7f35b2] px-6 py-5">
                            <div className="flex items-center gap-3">
                                <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-white/15">
                                    <AlertCircle className="text-white" size={24} />
                                </div>
                                <div>
                                    <h3 className="text-lg font-semibold text-white">Section B has begun</h3>
                                    <p className="mt-1 text-sm text-white/85">
                                        Review the case study details before answering.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="flex flex-1 flex-col justify-between p-6">
                            <p className="text-sm leading-relaxed text-gray-500">
                                We recommend reviewing the case study details thoroughly before answering.
                            </p>

                            <button
                                type="button"
                                onClick={onAcknowledge}
                                className="mt-5 w-full rounded-xl bg-[#7f35b2] px-4 py-2.5 text-sm font-medium text-white transition hover:bg-[#3bb290]"
                            >
                                OK
                            </button>
                        </div>
                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
};

export default SectionBIntroModal;
